// The product name, in ONE place.
//
// This fork inherited the previous product's name hardcoded across ~20 files,
// so a physical therapy clinic's login page carried it. Renaming by
// find-and-replace is how a rebrand ends up half-done and a stray original name
// surfaces on a page nobody checked.
//
// Everything user-visible reads from here. The next rename is one line, and
// grepping the old name across src/ returning nothing is then a real proof
// rather than a hopeful one.
//
// (This file was itself mangled by the very sweep it warns about - the sweep
// rewrote the old name inside this comment and gave the module an import of
// itself. Which is the argument, demonstrated.)
export const BRAND = "Galaw";
export const BRAND_LONG = "Galaw Rehabilitation Platform";
export const BRAND_TAGLINE = "Movement, measured.";
export default BRAND;
